"use client";

import { useEffect, useState } from "react";

import { Text } from "@/components/text/text.component";

import type { ProductQueryOptionValue } from "../productOptionsProduct/productOptionsProduct.component";
import { ProductOptionsColorValue } from "./productOptionsColorValue.component";

/** Color variant options (linked product per option value). */
export const ProductOptionsColor = ({
  slug,
  title,
  optionValues,
  optionId = "product",
}: ProductOptionsColorProps) => {
  const [selectedOptionId, setSelectedOptionId] = useState<string | null>();
  if (!slug) return null;
  const fieldsetName = `shop:${slug}:${optionId}`;
  useEffect(() => {
    // check localStorage for saved included product value and set it
    const savedValue = localStorage.getItem(fieldsetName);
    setSelectedOptionId(savedValue || optionValues?.[0]?.id || null);
  }, []);

  const selectedTitle =
    optionValues?.find((option) => option.id === selectedOptionId)?.title ??
    optionValues?.[0]?.title ??
    "";

  const renderOptionValues = () => {
    if (!optionValues?.length) return null;
    return optionValues.map(
      ({ title, description, image, id, product }, index) => {
        const selected = id === selectedOptionId;
        return (
          <ProductOptionsColorValue
            key={index}
            title={title}
            description={description}
            image={image}
            id={id}
            product={product}
            fieldsetName={fieldsetName}
            selected={selected}
            onChange={(value) => {
              setSelectedOptionId(value);
              localStorage.setItem(fieldsetName, value);
            }}
          />
        );
      },
    );
  };
  return (
    <fieldset
      name={fieldsetName}
      data-testid="product-options-color"
      className="mb-6 flex flex-col">
      <legend className="mb-4">
        <Text variant="h5" data-testid="product-options-color-title">
          {title || "Select included product"}
        </Text>
      </legend>
      <div
        data-testid="product-options-color-list"
        className="flex items-center gap-2">
        {renderOptionValues()}
        <Text>Color: {selectedTitle}</Text>
      </div>
    </fieldset>
  );
};

export type ProductOptionsColorProps = {
  slug: string;
  title?: string;
  optionValues: ProductQueryOptionValue[] | null;
  optionId?: string;
};
